<ng-container *ngIf="{url: tempUrl || tempThumbUrl} as vars">
  <div class="wide-pod-logo" *ngIf="displayType === displayTypes.widePodLogo" [ngClass]="{ photoPresent: subtype === 'photo' && vars.url }">
    <div class="logo-holder">
      <logo-handler #wideLogoHandler 
        [id]="id" 
        [maxSize]="maxSize"
        [publishCode]="publishCode"
        [public]="public"
        [imageData]="{ eventId: eventId, typeId: id, type: type, subtype: subtype, isTemplate: isTemplate ? 'yes' : 'no' }"
        (uploadStatusChanged)="updateUploadStatus($event)"
      ></logo-handler>
      <div class="uploading" [ngClass]="{ logo: subtype === 'logo' || !vars.url }" *ngIf="imageChanging">
        <mat-progress-spinner [diameter]="40" mode="indeterminate" color="primary"></mat-progress-spinner>
      </div>
      <photo *ngIf="!!vars.url && subtype === 'photo'" [data]="{photoURL: vars.url}" [size]="120"></photo>
      <img *ngIf="!!vars.url && subtype === 'logo'" [src]="vars.url">
      <div class="empty-placeholder" *ngIf="!tempUrl && !tempThumbUrl"><div class="empty-text">{{ placeholder }}</div></div>
    </div>
    <div class="right-side">
      <div class="wide-pod-actions">
        <div class="upload-button" [ngClass]="{ changing: imageChanging }">
          {{ uploadText }}
          <input [disabled]="imageChanging" title="" type="file" class="upload-button-input" (change)="wideLogoHandler.onFileChange($event)">
        </div>
        <div style="flex:1;"></div>
        <delete-button [deleteTitle]="finalDeleteTitle" [deleteText]="finalDeleteText"
          *ngIf="!imageChanging && (tempUrl || tempThumbUrl) && !public" (delete)="deleteImage()">
        </delete-button>
      </div>
      <div class="error" *ngIf="error">
        {{ error }}
      </div>
      <div class="hints" *ngIf="hints?.length">
        <div *ngFor="let hint of hints" class="hint">{{ hint }}</div>
      </div>
      <div style="flex:1;"></div>
      <div *ngIf="!!vars.url && !downloadingImage" class="download-link clickable" (click)="downloadImage(vars.url)">Download {{ subtype }}</div>
      <div *ngIf="!!downloadingImage" class="download-link">Downloading...</div>
    </div>
  </div> 
  <div class="photo" *ngIf="displayType === displayTypes.card">
    <div class="photo-holder">
      <div class="photo-top">
        <logo-handler #logoHandler 
          [id]="id" 
          [maxSize]="maxSize"
          [publishCode]="publishCode"
          [public]="public"
          [imageData]="{ eventId: eventId, typeId: id, type: type, subtype: subtype, isTemplate: isTemplate ? 'yes' : 'no'  }"
          (uploadStatusChanged)="updateUploadStatus($event)"
        ></logo-handler>
        <photo *ngIf="!!vars.url" [logo]="isLogo" [data]="{photoURL: vars.url}" [size]="120"></photo>
        <div *ngIf="!tempUrl && !tempThumbUrl" class="placeholder">{{ placeholder }}</div>
        <div class="uploading" *ngIf="imageChanging">
          <mat-progress-spinner [diameter]="40" mode="indeterminate" color="primary"></mat-progress-spinner>
        </div>
      </div>
      <div class="photo-menu">
        <div class="upload-button" [ngClass]="{ changing: imageChanging }">
          {{ uploadText }}
          <input [disabled]="imageChanging" title="" type="file" class="upload-button-input" (change)="logoHandler.onFileChange($event)">
        </div>
        <div style="flex:1;"></div>
        <delete-button [deleteTitle]="finalDeleteTitle" [deleteText]="finalDeleteText"
          *ngIf="!imageChanging && !!vars.url && !public" (delete)="deleteImage()">
        </delete-button>
      </div>
    </div>
    <div class="error" *ngIf="error">
      {{ error }}
    </div>
    <div class="hints" *ngIf="hints?.length">
      <div *ngFor="let hint of hints" class="hint">{{ hint }}</div>
    </div>
  
  </div>
  <div class="text" *ngIf="displayType === displayTypes.text">
    <logo-handler #logoHandler 
      [id]="id" 
      [maxSize]="maxSize"
      [text]="uploadText"
      [uniqueFormIdentifier]="uniqueFormIdentifier"
      [public]="false"
      [imageData]="{ typeId: id, type: type, accountId: accountId, onlyMain: noThumb ? 'yes' : 'no' }"
      (uploadStatusChanged)="updateUploadStatus($event)"
    ></logo-handler>
    <div class="error" *ngIf="error">
      {{ error }}
    </div>
  </div>

</ng-container>
